import React from 'react';
import {TouchableOpacity, View, Text} from 'react-native';
import tableStyle from '../../StyleSheets/TableCommonStyleSheet';
import {useLocale} from '../../Localization/LocaleContext';
import RolePermissionContext from '../../Component/RolePermissionContext';

const SaveButton = ({onClickButton, isDisabled, is_approve = true, title}) => {
  const {translate} = useLocale();
  return (
    <RolePermissionContext.Consumer>
      {permission => {
        const disabled = isDisabled || permission?.writeP === false;
        return (
          <View
            style={[
              tableStyle.gradientViewBGStyle,
              {
                backgroundColor: is_approve ? 'var(--color-primary)' : 'var(--color-error, #ef4444)',
                borderColor: is_approve ? 'var(--color-primary)' : 'var(--color-error, #ef4444)',
                marginRight: 0,
                opacity: disabled ? 0.55 : 1,
              },
            ]}>
            <TouchableOpacity onPress={onClickButton} disabled={disabled}>
              <Text
                style={[
                  tableStyle.saveBtnTxtStyle,
                  {
                    padding: 5,
                    paddingLeft: 10,
                    paddingRight: 10,
                  },
                ]}>
                {typeof title === 'string' ? translate(title) : title}
              </Text>
            </TouchableOpacity>
          </View>
        );
      }}
    </RolePermissionContext.Consumer>
  );
};

export default SaveButton;
